interface CarouselItem {
  title: string;
  desc: string;
  tag: string;
  img: string;
  alt: string;
}

const carouselItems: CarouselItem[] = [
  {
    title: '国产科幻崛起之路',
    desc: '从《流浪地球》到《三体》，国产科幻影视作品近年来的突破与创新。盘点十大里程碑式科幻作品，见证中国科幻的崛起时刻。',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20futuristic%20sci-fi%20composition%20with%20glowing%20orange%20and%20golden%20energy%20waves%20on%20dark%20background%2C%20epic%20cinematic%20atmosphere%2C%20soft%20nebula%20effects%2C%20warm%20ambient%20lighting%2C%20dramatic%20scale%2C%20no%20text%20no%20people&width=1000&height=600&seq=carousel-scifi-01&orientation=landscape',
    alt: '国产科幻崛起之路',
  },
  {
    title: '韩剧入坑指南2026',
    desc: '今年最值得追的韩剧清单，从悬疑推理到浪漫爱情，不同类型总有属于你的那一部。附完整追剧时间表，再也不怕错过更新。',
    tag: '追剧日历',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20romantic%20drama%20atmosphere%20with%20soft%20warm%20golden%20and%20pink%20ambient%20lighting%20on%20dark%20background%2C%20cinematic%20composition%2C%20elegant%20floating%20light%20particles%2C%20emotional%20aesthetic%2C%20no%20text%20no%20people&width=1000&height=600&seq=carousel-kdrama-02&orientation=landscape',
    alt: '韩剧入坑指南2026',
  },
  {
    title: '暑期必看高分电影',
    desc: '精选50部豆瓣8.0分以上的高分影片，涵盖动作、悬疑、喜剧、文艺等多种类型。这个暑假，让你的观影清单充实起来。',
    tag: '高分推荐',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20summer%20cinema%20vibe%20with%20warm%20sunset%20golden%20and%20amber%20color%20palette%20on%20dark%20background%2C%20floating%20film%20reels%20and%20popcorn%20silhouettes%2C%20soft%20atmospheric%20glow%2C%20entertainment%20aesthetic%2C%20no%20text%20no%20people&width=1000&height=600&seq=carousel-summer-03&orientation=landscape',
    alt: '暑期必看高分电影',
  },
  {
    title: '国漫崛起年度盘点',
    desc: '《凡人修仙传》《斗破苍穹》《完美世界》等国漫佳作持续发力，技术力与叙事力全面进阶。收录年度最美国漫作品赏析。',
    tag: '国漫专栏',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20dynamic%20Chinese%20ink%20painting%20style%20with%20warm%20golden%20and%20orange%20energy%20waves%2C%20fantasy%20atmosphere%20on%20dark%20background%2C%20flowing%20ink%20and%20light%20effects%2C%20cinematic%20epic%20aesthetic%2C%20no%20text%20no%20people&width=1000&height=600&seq=carousel-anime-04&orientation=landscape',
    alt: '国漫崛起年度盘点',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
            深度内容
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            精心策划的深度专题内容，带你发现更多好片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group relative bg-background-100 rounded-2xl overflow-hidden border border-background-200/80 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500/90 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-base md:text-lg font-heading font-bold text-background-50 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-background-50/80 line-clamp-2">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}